import { onAuthStateChanged, User, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import React, { useEffect, useState } from 'react'
import { auth, db } from '../config/firebase'
import { collection, deleteDoc, doc, onSnapshot, Timestamp, updateDoc } from 'firebase/firestore';

interface Order {
  id: string;
  name: string;
  status?: string; // Status might not be present on all orders
  toppings: string[];
  extra: string;
  createdAt: Timestamp;
}

const SignIn = () => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            // Hardcoded email as requested
            await signInWithEmailAndPassword(auth, 'admin@bestellsystem.app', password);
        } catch (error) {
            setError('Failed to sign in. Please check your password.');
            console.error(error);
        }
    };

    return (
        <div className="form-section">
            <h1 className="title">Sign In</h1>
            <form onSubmit={handleSubmit}>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    className="input-field"
                />
                <button type="submit" className="submit-button">Sign In</button>
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

function Manage() {
    const [user, setUser] = useState<User | null>();
    const [orders, setOrders] = useState<Order[]>([]);

    const handleLogout = async () => {
        await signOut(auth);
    };

    const editOrder = async (id: string, action: boolean) => {
        if(action) await deleteDoc(doc(db, 'orders', id))
        else await updateDoc(doc(db, 'orders', id), {
            status: 'In Arbeit'
        })
    }
    
    useEffect(() => {
        const unsub1 = onAuthStateChanged(auth, (user) => setUser(user))

        const unsub2 = onSnapshot(collection(db, 'orders'), (querySnapshot) => {
            const ordersData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as Order[];
            setOrders(ordersData);
        })

        return () => {
            unsub1()
            unsub2()
        };
    }, [])

    return (<div>
        { user ? <div>
            <main className="content">
            <section className="table-section">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h1 className="title">Bestellstatus</h1>
                    <button onClick={handleLogout} className="logout-button">Logout</button>
                </div>
                <table className="status-table">
                <thead>
                    <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Toppings</th>
                    <th>Extras</th>
                    <th>Bestellt am</th>
                    <th>Aktionen</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map(order => (
                    <tr key={order.id}>
                        <td>{order.name}</td>
                        <td>{order.status || 'Warteschlange'}</td>
                        <td>{order.toppings}</td>
                        <td>{order.extra}</td>
                        <td>{order.createdAt ? new Date(order.createdAt.seconds * 1000).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '-'}</td>
                        <td>
                            <button onClick={() => editOrder(order.id, order.status ? true : false)} className={order.status ? 'delete' : 'work'}>{order.status ? 'Löschen' : 'In Arbeit'}</button>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </section>
            </main>
        </div> : (
            <div className="signin-container">
                <SignIn />
            </div>
        ) }
    </div>)
}

export default Manage